import Button from '@mui/material/Button';

import Error from './component/Error';

function OfflineView() {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <Error
      title="Whoops!"
      description="Slow or no Internet connection. Please check your Internet settings."
      actions={
        <Button
          color="primary"
          variant="contained"
          sx={{ width: 'fit-content' }}
          onClick={handleRetry}
        >
          Retry
        </Button>
      }
    />
  );
}

export default OfflineView;
